import React from 'react';

import { ContextGlobal as CG } from 'contexts';
import { useForm } from 'components/form';
import * as Form from 'components/form';
import * as Page from 'components/page';

import * as Styled from './StyledContratos';

export function ContratosPin({ t, cv, email, onBack, onVerified }) {
    const { emitAlert, emitToast, state } = React.useContext(CG);
    const form = useForm({ pin: '' });

    const onSubmit = values => {
        const pin = String(values.pin || '').trim();
        return cv
            .verifyPin({ email, pin })
            .then(res => {
                form.submited();
                if (res && res.token) onVerified();
            })
            .catch(err => {
                form.submited();
                const data = err?.response?.data || {};
                if (data.code === 'PIN_INCORRECT') {
                    emitAlert(t('pin.incorrect', { remaining: data.attemptsRemaining }));
                } else if (data.code === 'PIN_LOCKED') {
                    emitAlert(t('pin.locked'));
                } else if (data.code === 'PIN_INVALID_OR_EXPIRED') {
                    emitAlert(t('pin.expired'));
                } else {
                    emitAlert(t('errors.generic'));
                }
            });
    };

    const onResend = () =>
        cv
            .requestPin({ email, locale: state.language })
            .then(() => emitToast(t('pin.resent')))
            .catch(() => emitAlert(t('errors.generic')));

    const fields = {
        pin: {
            autoComplete: 'one-time-code',
            autoFocus: true,
            error: form.errors.pin,
            inputMode: 'numeric',
            label: t('pin.label'),
            maxLength: 6,
            name: 'pin',
            type: 'text',
            value: form.values.pin,
            onChange: form.handleChange,
        },
    };

    return (
        <>
            <Page.Title>{t('pin.title')}</Page.Title>
            <Page.Descr>{t('pin.descr', { email })}</Page.Descr>
            <Form.Form name="ContratosPinForm" onSubmit={ev => form.handleSubmit(ev, onSubmit)}>
                <Form.Field {...fields.pin} />
                <Form.Submt {...form} text={t('pin.submit')} />
            </Form.Form>

            <Styled.Help>{t('pin.help')}</Styled.Help>

            <Styled.LinkRow>
                <button type="button" onClick={onBack}>
                    {t('pin.back')}
                </button>
                <button type="button" onClick={onResend}>
                    {t('pin.resend')}
                </button>
            </Styled.LinkRow>
        </>
    );
}
export default ContratosPin;
